import { h, FunctionComponent } from 'preact';
import classnames from 'classnames';

export enum CheckboxVariant {
    NORMAL = 'normal',
    ALTERNATIVE = 'alternative',
    FLUSH = 'flush',
    MULTILINE = 'multiline',
}

export interface ICheckboxProps
    extends Omit<h.JSX.HTMLAttributes<HTMLInputElement>, 'label' | 'defaultValue'> {
    variant?: CheckboxVariant;
    checked?: boolean;
    className?: string;
    defaultValue?: string;
    disabled?: boolean;
    indeterminate?: boolean;
    label: string | h.JSX.Element;
    minimal?: boolean;
    name: string;
    value?: string;
}

const Checkbox: FunctionComponent<ICheckboxProps> = ({
    variant = CheckboxVariant.NORMAL,
    checked,
    className,
    disabled,
    indeterminate = false,
    label = '',
    name,
    value,
    ...rest
}) => (
    <label
        className={classnames('c-trigger c-trigger--checkbox', className, {
            'c-trigger--alt': variant === CheckboxVariant.ALTERNATIVE,
            'c-trigger--flush': variant === CheckboxVariant.FLUSH,
            'c-trigger--multiline': variant === CheckboxVariant.MULTILINE,
        })}
    >
        <input
            name={name}
            className={classnames('c-trigger__input u-visually-hidden', {
                'c-trigger__input--checked': checked,
                'c-trigger__input--disabled': disabled,
            })}
            type="checkbox"
            value={value}
            checked={checked}
            disabled={disabled}
            ref={(elem) => {
                if (elem) {
                    // eslint-disable-next-line no-param-reassign
                    elem.indeterminate = indeterminate;
                }
            }}
            {...rest}
        />
        <span className="c-trigger__label">{typeof label === 'string' ? label.trim() : label}</span>
    </label>
);

export default Checkbox;
